const SET_PLAN_DATA: string = 'SET_PLAN_DATA';
const SET_DATA_LOADING = 'SET_DATA_LOADING';
const SET_DATA_ERROR = 'SET_DATA_ERROR';

export const PLAN_SUMMARY_ACTION_TYPES = {
    SET_PLAN_DATA,
    SET_DATA_LOADING,
    SET_DATA_ERROR,
};
